module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home/home.component.html
// module id = ./src/app/components/home/home.component.html
// module chunks = main